/**
 * Created by lihanying on 2017/7/15.
 */
/**
 * Created by lihanying on 2017/7/14.
 */
import React from 'react'
import { Modal, Table } from 'antd'
import { col_service } from '../../../components/CommonTable/columns'
export default class extends React.Component {
  render() {
    const { visible, list, serviceList } = this.props
    //回合消费
    const columns = [
      {
        title: '球台',
        dataIndex: 'tname',
        key: 'tname',
      },
      {
        title: '开始时间',
        dataIndex: 'start_time',
        key: 'start_time',
      },
      {
        title: '结束时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '上场玩家',
        dataIndex: 'winner_fnickname',
        key: 'winner_fnickname',
        render: (text) =>
          text &&
          text.map((item, idx) => {
            return <div key={idx}>{item}</div>
          }),
      },
      {
        title: '计钟玩家',
        dataIndex: 'fnickname',
        key: 'fnickname',
      },
      {
        title: '时长',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '原价',
        dataIndex: 'origin_price',
        key: 'origin_price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
      {
        title: '奖金',
        dataIndex: 'profit',
        key: 'profit',
      },
      {
        title: '串台',
        dataIndex: 'ctname',
        key: 'ctname',
      },
      {
        title: '暂停',
        dataIndex: 'status',
        key: 'status',
      },
    ]
    //商品消费
    const columnsCommodity = [
      {
        title: '用户昵称',
        dataIndex: 'nickname',
        key: 'nickname',
      },
      {
        title: '商品名',
        dataIndex: 'cname',
        key: 'cname',
      },
      {
        title: '台名',
        dataIndex: 'tname',
        key: 'tname',
      },
      {
        title: '购买时间',
        dataIndex: 'time',
        key: 'time',
      },
      {
        title: '数量',
        dataIndex: 'num',
        key: 'num',
      },
      {
        title: '总金额',
        dataIndex: 'price',
        key: 'price',
      },
      {
        title: '单价',
        dataIndex: 'uprice',
        key: 'uprice',
      },
    ]

    const data =
      list.list &&
      list.list.map((item) => {
        if (item.wnickname === item.fnickname) {
          //上场玩家相同情况
          item.winner_fnickname = [item.fnickname]
        } else {
          item.winner_fnickname = [item.wnickname, item.fnickname]
        }
        return item
      })

    return (
      <div>
        <Modal
          title="消费详情"
          visible={visible}
          onOk={this.props.handleOk}
          onCancel={this.props.handleCancel}
          width="1300px"
        >
          <Table
            rowKey="id"
            title={() => {
              return '回合消费'
            }}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 5 }}
            size="middle"
          />
          <Table
            rowKey="id"
            title={() => {
              return '商品消费'
            }}
            columns={columnsCommodity}
            dataSource={list.goodsList}
            pagination={{ pageSize: 5 }}
            size="middle"
          />
          <Table
            rowKey="id"
            title={() => {
              return '服务消费'
            }}
            columns={col_service}
            dataSource={serviceList}
            pagination={{ pageSize: 5 }}
            size="middle"
          />
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubBusiness/component/modalSn.js